import FieldConfig from "../../../proto/field-config";
import FieldDropdown from "../../dropdown/dropdown";
import formatTime from "../../../../gd/format/time";

export default class FieldTime extends FieldDropdown {

    constructor(config:FieldConfig) {
        super(config);

        this.typeLabel      = "Time"
        this.icon           = 'i5-my-time';


        // INIT OPTION
        this.options            = []
        const timeStep          = 15
        // const startMoment = this.props.minValue ? Moment(this.props.minValue) :
        //     this.props.selectedValue ? Moment(this.props.selectedValue).startOf('day') :
        //         Moment().startOf('day');
        const startMoment = moment().startOf('day')

        // 24 hours is 96 steps of 15 minutes (this.props.timeStep)
        const steps = Math.floor(24 * 60 / timeStep); // this.props.timeStep

        for (let i = 0; i < steps; i++) {
            const option = moment(startMoment).add(timeStep * i, 'minutes');

            this.options.push({
                label   : formatTime(option),
                // value   : option
                value   : {hours: option.hours(), minutes: option.minutes()}
            })
        }

        // console.log(this.options)
        //




        // if true will add no value option to options list (by default true for custom fields)
        this.noValueOption      = false
        this.noValueOptionLabel = _.get(config,'noValueOptionLabel','Not specified');

        // default placeholder for FORM element
        this.placeholder        = _.get(config,'placeholder','Please select');

        this.showMenuMore       = false
        this.isSearchable       = true;

        this.components.PopoverMenuMore         = null

        // this.components = _.assign({}, this.components, {
        //     // PopoverMenuMore     : ContactTypePopoverMenuMore,
        //     //
        //     // glistGroupStandard  : FieldContactType_GlistGroupStandard
        // })
    }


    _getOption(value:any) {

        if (this.hasOptionWithNullValue || !_.isNil(value)) {
            const option = _.find(this.getOptions(), option => _.isEqual(option.value,  value));
            if (option) return option;
        }

        return false;
    }


    groupValue(value:any) {
        return _.get(this._getOption(value),'value', null);
    }

    groupSortValue(value:any) {
        return _.indexOf(this.options, this._getOption(value));
    }

}
